import { TranslationService } from "../../services/TranslationService";
import ModalService from "./bootstrap/Modal";
import Label from "./form/Label";
import { RequiredManager, ValidationMessage } from "./RequieredManager";
import { ContactService } from "../../services/ContactService";
import { handleErrorWithToast } from "../../utils/RequestUtils";
import { ToastService } from "./bootstrap/Toast";
import CompanyService from "../../services/CompanyService";
import { useState } from "react";
import { toEvent } from "../../utils/FuncUtils";

type SupportButtonFormRequest = {
    name: string,
    email: string,
    country: string,
    phone: string,
}

export const Message = () => {
    const name = CompanyService.getCompanyToken()!.firstname + ' ' + CompanyService.getCompanyToken()!.lastname;
    const email = CompanyService.getCompanyToken()!.emailaddress;
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('')
    const [model, setModel] = useState<SupportButtonFormRequest>({
        name,
        email,
        country: '',
        phone: ''
    });

    const requiredManager = new RequiredManager();
    const changeModelNoRequired = <T extends keyof SupportButtonFormRequest>(field: T) => (value: string) => setModel(x => ({ ...x, [field]: value }));
    const changeModel = <T extends keyof SupportButtonFormRequest>(field: T) => requiredManager.makeRequiredWithId((value: string) => setModel(x => ({ ...x, [field]: value })), field);
    const setMessageRequired = requiredManager.makeRequired(({ target: { value } }: React.ChangeEvent<HTMLTextAreaElement>) => setMessage(value));

    const onSubmit = async () => {
        if (!requiredManager.validate()) {
            return;
        }
        setLoading(true);
        await handleErrorWithToast(ContactService.sendMessage({
            ...model,
            message,
            company: CompanyService.getCompanyToken()!.companyid
        })).finally(() => setLoading(false));

        ToastService.showToast(
            TranslationService.translate.OnContactMessage,
            TranslationService.translate.OnContactTitle,
            "success"
        );
        ModalService.hideModal();
    };

    return (<>
        <div className="">
            <Label label={TranslationService.translate.ContactSupportMsg} />
            <div className="d-flex flex-row gap-4 justify-content-between mb-2">
                <Label className="w-100" label={TranslationService.translate.Name}>
                    <input
                        className="form-control"
                        onChange={toEvent(changeModel("name"))}
                        placeholder={TranslationService.translate.Name}
                        type="text"
                        defaultValue={model.name}
                    />
                    <ValidationMessage
                        defaultValue={model.name}
                        onChange={requiredManager.getValidation('name')}
                    />
                </Label>
                <Label className="w-100" label={TranslationService.translate.Email}>
                    <input
                        className="form-control"
                        onChange={toEvent(changeModel("email"))}
                        placeholder={TranslationService.translate.Email}
                        type="text"
                        defaultValue={model.email}
                    />
                    <ValidationMessage
                        defaultValue={model.email}
                        onChange={requiredManager.getValidation('email')}
                    />
                </Label>

            </div>
            <div className="d-flex flex-row gap-4 justify-content-between mb-2">
                <Label className="w-100" label={TranslationService.translate.Country}>
                    <input
                        className="form-control"
                        onChange={toEvent(changeModelNoRequired("country"))}
                        placeholder={TranslationService.translate.Country}
                        type="text"
                        defaultValue={model.country}
                    />
                </Label>
                <Label className="w-100" label={TranslationService.translate.Phone}>
                    <input
                        className="form-control"
                        onChange={toEvent(changeModelNoRequired("phone"))}
                        placeholder={TranslationService.translate.Phone}
                        type="text"
                        defaultValue={model.phone}
                    />
                </Label>
            </div>
            <div className="d-flex flex-row gap-4 justify-content-between">
                <Label className="w-100" label={TranslationService.translate.Message}>
                    <textarea
                        rows={5}
                        className="form-control"
                        onChange={setMessageRequired}
                        placeholder={TranslationService.translate.Message}
                        defaultValue={message}
                    />
                    <ValidationMessage
                        defaultValue={message}
                        onChange={requiredManager.getValidation('message')}
                    />
                </Label>
            </div>
        </div>
        <div className="modal-footer pb-0 pe-0">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{TranslationService.translate.Close}</button>
            <button type="button" onClick={() => onSubmit()} className={"btn btn-primary"}>
                {TranslationService.translate.Send}
                {loading && <i className="fas fa-spinner-third fa-spin third ms-2"></i>}
            </button>
        </div>
    </>);
}

export const SupportButton = () => {
    const openTechnicalSupportModal = () => {
        ModalService.showDefaultModal({
            title: TranslationService.translate.ContactSupport,
            hideClose: true,
            size: 'modal-lg',
            message: Message
        });
    };

    return (<div onClick={openTechnicalSupportModal} className="floating-button">
        {TranslationService.translate.ContactSupport}
    </div>)
}
